/**
 * Opsi react-hot-toast yang mengikuti spesifikasi .toast Design System KLH/BPLH v2.1:
 * kartu surface, garis --line, border kiri 4px berwarna status, radius 12px,
 * padding 13/14, elevasi 2, ukuran teks 13.5px.
 *
 * Penanda `!` diperlukan karena react-hot-toast menempelkan gaya inline pada
 * elemen toast; deklarasi !important pada kelas mengalahkan gaya inline tersebut.
 *
 * react-hot-toast menimpa (bukan menggabung) className saat opsi per-tipe diberikan,
 * jadi kelas dasar disusun ulang di tiap tipe.
 */
const BASE =
  "!rounded-ds-md !border !border-line !border-l-4 !bg-surface !px-[14px] !py-[13px] !text-[13.5px] !text-ink-900 !shadow-ds-2";

const dsToastOptions = {
  duration: 5000,
  className: `${BASE} !border-l-line-strong`,
  success: { className: `${BASE} !border-l-success` },
  error: { className: `${BASE} !border-l-danger` },
  loading: { className: `${BASE} !border-l-b-500` },
};

export default dsToastOptions;
